module.exports = __webpack_public_path__ + "band_1.463c74a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_1.png
// module id = EpwK
// module chunks = 0